module.exports = __webpack_public_path__ + "static/media/trofimov_8.e2084c82.pdf";